import { render } from "./ScheduledServicesCalendarView.vue?vue&type=template&id=36305dd6&scoped=true"
import script from "./ScheduledServicesCalendarView.vue?vue&type=script&lang=js"
export * from "./ScheduledServicesCalendarView.vue?vue&type=script&lang=js"

import "./ScheduledServicesCalendarView.vue?vue&type=style&index=0&id=36305dd6&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36305dd6"]])

export default __exports__